import React, { forwardRef, useState } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import GoogleCloudRegistryMappingForm from './GoogleCloudRegistryMappingForm';
import message from "components/CustomMessage";
import _ from 'lodash';

function GoogleCloudRegistryCredentialsForm(props, ref){
    const [JSONData, setJSONData] = useState()
    const [fileList, setFileList] = useState([]);

    const fileChange = (data) => {
        if(data.file.name.split('.').pop() !== 'json'){
            message.error("Invalid format. JSON file is allowed only.");
            setFileList([]);
            setJSONData(undefined)
            return;
        }
        if(data.file.status === 'removed') {
            setFileList([])
            setJSONData(undefined)
            return
        }
        let fileList = [...data.fileList];
        fileList = fileList.slice(-1);
        setFileList(fileList);
    }

    const readJSONFile = (file) => {
        const reader = new FileReader();

        reader.readAsText(file);
        reader.onload = function() {
            const jsonData = JSON.parse(reader.result)
            setJSONData(jsonData)
        };
        return false;
    }

    const fields = [{
        name: "jsonFile",
        label: "Upload JSON file",
        type: FieldTypes.ATTACHMENT,
        required: true,
        uploadProps: {
            accept: ".json",
            onChange: fileChange,
            beforeUpload: readJSONFile,
            fileList
        },
        rules: [{
            validator : () => {
                if(!_.isUndefined(JSONData) && _.isEmpty(JSONData)) {
                    return Promise.reject("JSON file is required.")
                }
                return Promise.resolve()
            }
        }]
    }]

    const beforeSave = (data) => {
        return {
            ...JSONData,
            name: data.name
        }
    }
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            versionField={false}
            beforeSave={beforeSave}
            MappingForm={GoogleCloudRegistryMappingForm}
        />
    )
}

export default forwardRef(GoogleCloudRegistryCredentialsForm);